import MultiSelect from "@khanacademy/react-multi-select";
import { Button, Col, Drawer, Form, Row, Space, Spin } from "antd";
import { Component } from "react";
import logger from '../../utils/logger.js';
import { GET, POST } from "../constants/request-type";
import { get_all_user, mailing, user } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";
import "../styles/general.css";

const token = sessionStorage.getItem("auth_token");

class Send_mail extends Component {
  state = {
    visible: false,
    data1: [],
    data2: [],
    emails: [],
    classes: {
      text: "Utilisateur",
      value: "user"
    },
    html: this.props.row.html,
    title: this.props.row.title,
    from: this.props.row.from,
    load: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    var list = [];

    const request_details_user = {
      type: GET,
      url: service_api,
      route: user + "/" + get_all_user,
      data: null,
      token: token
    };

    try {
      const response_user = await MakeRequestAsync(request_details_user);
      const decryptedValue = decryptSingleData(response_user.data.user);
      decryptedValue?.map((data) =>
        list.push({
          label: data?.email,
          value: data?.email
        })
      );
      this.setState({
        load: false,
        data1: list
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });
    const { emails, title, html } = this.state;
    const data = {
      emails: [...emails],
      subject: title,
      html: html
    };

    if (data.emails.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", "Aucune selection ");
    }

    for (var i = 0; i < emails.length; i++) {
      const request_detail = {
        type: POST,
        url: service_api,
        route: mailing + "/" + "send-email",
        data: {
          email: emails[i],
          subject: title,
          html: html
        },
        token: token
      };

      try {
        await MakeRequestAsync(request_detail);
        logger.log("Envoie terminé");
      } catch (err) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          `${err.response.data.message}`
        );
      }
    }

    openNotificationWithIcon("success", "Les mails ont bien été envoyés");

    return setTimeout(() => window.location.reload(), 1000);
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {  data1, load } = this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Envoyer
        </Button>
        <Drawer
          title="Send push notification"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Submit
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}></Row>
            <Row gutter={16} style={{ marginTop: 30 }}>
              <Col span={24}>
                <MultiSelect
                  options={data1}
                  onSelectedChanged={(emails) => this.setState({ emails })}
                  selected={this.state.emails}
                />
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Send_mail;
